import { setOrderDetails, setNonStandardEquipmentItemDetails, getNonStandardEquipmentItemDetails, getStateDropdown,setVendorDetailsNext, setVendorDetailsErrorCount, getVendorDetails, setVendorDetails, setIsSubmitted } from './action'

const dispatchSetOrderDetails = (dispatch:Function) => (orderDetails:any) => {
    dispatch(setOrderDetails(orderDetails));
};

const dispatchGetCatalogItemDetails = (dispatch:Function) => (catalogRequestBody:{}) => {
    dispatch(getNonStandardEquipmentItemDetails(catalogRequestBody));
};
const dispatchSetCatalogItemDetails = (dispatch:Function) => (catalogRequestBody:{}) => {
    dispatch(setNonStandardEquipmentItemDetails(catalogRequestBody, ''));
};
const dispatchGetStateDropdown = (dispatch:Function) => () => {
    dispatch(getStateDropdown());
};
const dispatchSetVendorDetailNext = (dispatch:Function)=>(vendorDetailNext:boolean) => {
    dispatch(setVendorDetailsNext(vendorDetailNext));
};
const dispatchSetVendorDetailsErrorCount = (dispatch:Function)=>(vendorerrorCount:any) => {
    dispatch(setVendorDetailsErrorCount(vendorerrorCount));
};
const dispatchGetVendorDetails = (dispatch: Function) => (addressBookNo: any) => {
    dispatch(getVendorDetails(addressBookNo));
}
const dispatchSetVendorDetails = (dispatch: Function) => (addressBookNo: any) => {
    dispatch(setVendorDetails(addressBookNo));
}
const dispatchSetIsSubmitted = (dispatch:Function)=>(isSubmitted:boolean) => {
    dispatch(setIsSubmitted(isSubmitted));
};
const operations = {
    dispatchSetOrderDetails,
    dispatchGetCatalogItemDetails,
    dispatchGetStateDropdown,
    dispatchSetVendorDetailNext,
    dispatchSetVendorDetailsErrorCount,
    dispatchGetVendorDetails,
    dispatchSetVendorDetails,
    dispatchSetIsSubmitted,
    dispatchSetCatalogItemDetails
}

export default operations;